/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React, { useState } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import { uid } from 'react-uid';
import {
    object, string, arrayOf, shape, func,
} from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { getLanguageName, getCurrencyName, setCurrencyName } from '../../../../../../../state/ducks/Member/ducks/Auth/helper/helper';
import { setCurrency } from '../../../../../../../state/ducks/App/App-Actions';
import { getCurrencyData } from '../../../../../../../state/ducks/App/App-Selectors';

const styles = (theme) => ({
    MenuDropdown: {
        padding: '0 20px',
    },
    ButtonMenuDropdown: {
        color: theme.palette.black,
        textTransform: 'none',
        fontSize: '14px',
        fontWeight: '600',
        paddingLeft: '20px',
        paddingRight: '20px',
        borderRadius: '3px',
        border: `1px solid ${theme.palette.colorNeutral30}`,
        '&:hover': {
            backgroundColor: 'transparent',
        },
        '& span': {
            justifyContent: 'space-between',
        },
        width: '100%',
    },
    ArrowDropDown: {
        color: theme.palette.black,
    },
    MenuItem: {
        fontSize: '14px',
        fontWeight: '600',
    },
    list: {
        backgroundColor: theme.palette.colorNeutral91,
        padding: '0',
        border: `0.5px solid ${theme.palette.colorNeutral92}`,
        '& li': {
            borderBottom: `1px solid ${theme.palette.colorNeutral92}`,
        },
        width: '260px',
    },
});

const MenuDropdown = ({
    menu, classes, title, handleClose, languageChange, setCurrencyData,
}) => {
    const [anchorEl, setAnchorEl] = useState(null);

    const handleOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const renderOptionLabel = () => {
        if (['language', 'langue'].includes(title) && menu && Array.isArray(menu) && menu.length && getLanguageName()) {
            const languageItem = menu.find((item) => item.link === getLanguageName());
            if (languageItem) {
                return languageItem.label;
            }
        } else if (title === 'currency' && menu && Array.isArray(menu) && menu.length && getCurrencyName()) {
            const currencyItem = menu.find((item) => item.label.substring(0, 3) === getCurrencyName());
            if (currencyItem) {
                return currencyItem.label;
            }
        }

        return null;
    };

    const handleMenuItemClick = (event, index, value, updateLanguageFun) => {
        setAnchorEl(null);
        if (['language', 'langue'].includes(title)) {
            languageChange(value.link, updateLanguageFun);
        } else {
            const [currencyName, currencySymbol] = value.label.split(' '); // ['USD', '$'] or ['EUR', '€'], etc.
            setCurrencyData({ currencyName, currencySymbol });
            setCurrencyName(value.label.substring(0, 3));
        }
        handleClose();
    };

    const handleCloseDropdown = () => {
        setAnchorEl(null);
    };

    const renderOptions = () => {
        if (Array.isArray(menu) && menu.length) {
            return (
                menu.map((item, index) => (
                    <MenuItem
                        className={classes.MenuItem}
                        key={uid(item)}
                        selected={['language', 'langue'].includes(title) ? item.link === getLanguageName() : item.label.substring(0, 3) === getCurrencyName()}
                        onClick={(event) => handleMenuItemClick(event, index, item)}
                    >
                        {item.label}
                    </MenuItem>
                ))
            );
        }
        return null;
    };

    return (
        <div className={classes.MenuDropdown}>
            <div>
                <Button id={`${title?.toLowerCase()}-button`} data-testid={`${title?.toLowerCase()}-button`} className={classes.ButtonMenuDropdown} aria-controls="simple-menu" aria-haspopup="true" onClick={handleOpen} endIcon={<ArrowDropDownIcon className={classes.ArrowDropDown} />}>
                    {renderOptionLabel()}
                </Button>
            </div>
            <Menu
                className={classes.Menu}
                classes={{ list: classes.list }}
                id="simple-menu"
                data-testid="simple-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleCloseDropdown}
                getContentAnchorEl={null}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                transformOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                {renderOptions()}
            </Menu>
        </div>
    );
};

MenuDropdown.propTypes = {
    menu: arrayOf(shape({
        label: string.isRequired,
        link: string.isRequired,
    })).isRequired,
    classes: object.isRequired,
    title: string.isRequired,
    handleClose: func.isRequired,
    languageChange: func.isRequired,
    setCurrencyData: func.isRequired,
};

const mapStateToProps = (state) => ({
    currencyData: getCurrencyData(state),
});

const mapDispatchToProps = (dispatch) => ({
    setCurrencyData: bindActionCreators(setCurrency, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(MenuDropdown));
